import Helper from "./Helper";

class Header {
  constructor(config = {}) {
    const {
      scrollDistanceClass,
      headerSelector,
      menuTogglerSelector,
      menuLevelTogglerSelector,
      menuLevelNoTogglerSelector,
      menuContainerSelector,
      mobileTogglerSelector,
      mobileContainerSelector,
      postContainerSelector,
      languageTogglerSelector,
      languageContainerSelector,
      searchTogglerSelector,
      searchContainerSelector,
      reportTogglerSelector,
      reportContainerSelector
    } = config;

    this.body = document.querySelector("body");
    this.scrollDistanceClass = document.querySelector(scrollDistanceClass);
    this.header = document.querySelector(headerSelector);
    this.menuToggler = document.querySelectorAll(menuTogglerSelector);
    this.menuLevelToggler = menuLevelTogglerSelector;
    this.menuLevelNoToggler = menuLevelNoTogglerSelector;
    this.menuContainer = document.querySelectorAll(menuContainerSelector);
    this.mobileToggler = document.querySelectorAll(mobileTogglerSelector);
    this.mobileContainer = document.querySelectorAll(mobileContainerSelector);
    this.mobileContainerClass = mobileContainerSelector;
    this.postContainer = document.querySelectorAll(postContainerSelector);
    this.postContainerClass = postContainerSelector;
    this.languageToggler = document.querySelectorAll(languageTogglerSelector);
    this.languageContainer = document.querySelectorAll(languageContainerSelector);
    this.searchToggler = document.querySelectorAll(searchTogglerSelector);
    this.searchContainer = document.querySelectorAll(searchContainerSelector);
    this.reportToggler = document.querySelectorAll(reportTogglerSelector);
    this.reportContainer = document.querySelectorAll(reportContainerSelector);

    this.menuOpen = {
      "menu" : false,
      "mobile" : false,
      "language" : false,
      "search"   : false,
      "report"   : false
    };

    this.submenu = 1;
    this.submenuMobile = [];
    this.submenuId = null;
    this.submenuChildrenId = null;
    this.activeMenuArray = [];

    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener("scroll", (e) =>{
      this.minimizeHeader();
    });

    this.postContainer.forEach(post => {
      if(post.nextElementSibling){
        post.nextElementSibling.insertAdjacentElement("beforeend", post);
      }
    });

    this.menuToggler.forEach(toggle => {
      let wrap = document.createElement("div");
      let wrapInner = document.createElement("div");
      let wrapContent = document.createElement("div");
      let wrapHeadline = document.createElement("li");
      let wrapHeadlineLink = document.createElement("a");

      wrap.classList.add("menu__wrap");
      wrapInner.classList.add("menu__wrap--inner");
      wrapContent.classList.add("menu__wrap--content");
      wrapHeadlineLink.classList.add("menu__wrap--headline");

      let headline = toggle.querySelector(".menu__link-text").innerText;
      let content =  toggle.querySelector(".menu--level-1");
      let post = toggle.querySelector(this.postContainerClass);

      wrapHeadlineLink.href = toggle.querySelector(".menu__link").href;
      wrapHeadlineLink.innerText = headline;
      wrapHeadline.insertAdjacentElement("afterbegin", wrapHeadlineLink);
      content.insertAdjacentElement("afterbegin", wrapHeadline);
      wrapContent.insertAdjacentElement("beforeend", content);
      wrapInner.insertAdjacentElement("afterbegin", wrapContent);
      wrap.insertAdjacentElement("afterbegin", wrapInner);

      if(post){
        wrapInner.insertAdjacentElement("beforeend", post);
      }

      toggle.insertAdjacentElement("beforeend", wrap);
      this.menuContainer = document.querySelectorAll(".menu__wrap");

      if(document.documentElement.clientWidth <= 1240){
        toggle.querySelector(".menu__link").addEventListener("click", event => {
          event.preventDefault();
          event.stopPropagation();
          this.closeSubmenu = false;
          this.toggleMainMenu(toggle, event.offsetX);
        });
      } else {
        toggle.querySelector(".menu__link").addEventListener("mouseover", mouseoverevent => {
          this.submenuMouseover = toggle.getAttribute("id");
          this.closeSubmenu = false;
          setTimeout(event => {
            if(this.submenuMouseover == toggle.getAttribute("id") && this.submenuId != toggle.getAttribute("id")) {
              mouseoverevent.preventDefault();
              mouseoverevent.stopPropagation();
              this.toggleMainMenu(toggle);
              this.submenuId = toggle.getAttribute("id");
            }
          },200);
        });
      }

      toggle.querySelector(".menu__link").addEventListener("mouseout", e => {
        this.submenuMouseover = false;
        this.closeSubmenu = true;
      });

      document.querySelector(".header__top").addEventListener("mouseout", e => {
        this.closeSubmenu = true;
        setTimeout(event => {
          if(!this.menuOpen['report']) {
            this.closeAllMenus(true);
          }
        },200);
      });

      this.menuContainer.forEach(toggle => {
        toggle.addEventListener("mouseout", e => {
          this.closeSubmenu = true;
          setTimeout(event => {
              this.closeAllMenus(true);
          },200);
        })
        toggle.addEventListener("mouseover", e => {
          this.closeSubmenu = false;
        });
      });
    });

    this.bindMenuTogglerEvents();

    this.mobileToggler.forEach(toggle => {

      toggle.addEventListener("click", e => {
        e.preventDefault();
        this.toggleMenu(this.mobileContainer, "mobile", toggle);

        this.activeMenuArray = [];
        document.querySelectorAll(".menu__item--ancestor-active > a").forEach(toggle => {
          this.activeMenuArray.push(toggle);
        });

        if(this.activeMenuArray.length > 0 && this.menuOpen['mobile']){
          var i = 0;
          var activeMenuInt = setInterval(e => {

            document.querySelector(".menu__item--ancestor-active > a").dispatchEvent(new Event('click', {cancelable: true}));

            if(i == this.activeMenuArray.length - 1){
              clearInterval(activeMenuInt);
            }
            i++;
          },20);
        }
      });
    });

    this.languageToggler.forEach(toggle => {
      toggle.addEventListener("click", (e) => {
        this.toggleMenu(this.languageContainer, "language", toggle);
      });
    });

    this.searchToggler.forEach(toggle => {
      toggle.addEventListener("click", (e) => {
        this.toggleMenu(this.searchContainer, "search", toggle);
      });
    });

    this.reportToggler.forEach(toggle => {
      toggle.addEventListener("click", (e) => {
        this.toggleMenu(this.reportContainer, "report", toggle);
      });
    });

    setTimeout(() => {
      if (!!document.querySelector('#nswow-search-field')) {
          document.querySelector("#nswow-search-field").addEventListener("input", (e) => {
          const observer = new MutationObserver((mutations, obs) => {
            const results = document.querySelector(".result-item");
            if (results) {
              this.adjustSearch();
              obs.disconnect();
              return;
            }
          });

          observer.observe(document, {
            childList: true,
            subtree: true
          });
        });
      }
    }, 1000);

    this.adjustBreadcrumbs();

    document.onkeydown = (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.closeAllMenus();
      }
    };
  }

  bindMenuTogglerEvents(submenu){
    if(document.documentElement.clientWidth <= 1240){
      let menuLevelToggler = submenu ? submenu.querySelectorAll(".menu__item") :  document.querySelectorAll(this.menuLevelToggler);
      menuLevelToggler.forEach(toggle => {
        toggle.querySelector(":scope > .menu__link").addEventListener("click", mouseoverevent => {
          mouseoverevent.preventDefault();
          mouseoverevent.stopPropagation();
          this.toggleMenuLevels(
            toggle.querySelector(".menu"),
            toggle.querySelector(".menu__link"),
            toggle,
            mouseoverevent.offsetX
          );
        });
      });
    } else {
      let menuLevelToggler = submenu ? submenu.querySelectorAll(".menu__item") :  document.querySelectorAll(this.menuLevelToggler);
      menuLevelToggler.forEach(toggle => {
        toggle.addEventListener("mouseover", mouseoverevent => {
          this.submenuChildrenMouseover = toggle.getAttribute("id");
          setTimeout(event => {
            if(toggle.querySelector(".menu") && this.submenuChildrenMouseover == toggle.getAttribute("id")) {
              mouseoverevent.preventDefault();
              mouseoverevent.stopPropagation();
              this.toggleMenuLevels(
                toggle.querySelector(".menu"),
                toggle.querySelector(".menu__link-text").innerText,
                toggle
              );
              this.submenuChildrenId = toggle.getAttribute("id");
            }
          },10);
        });
      });
      let menuLevelNoToggler = document.querySelectorAll(this.menuLevelNoToggler);
      menuLevelNoToggler.forEach(toggle => {
        toggle.addEventListener("mouseover", mouseoverevent => {
          if(toggle.closest('.menu').classList.contains('menu--level-1')){
            this.removeMenuLevelsDesktop('','', false, 2);
          } else if (toggle.closest('.menu').classList.contains('menu--level-2')){
            this.removeMenuLevelsDesktop('','', false, 3);
          }
        });
      });
    }
  }

  minimizeHeader() {
    let scrollDistance = window.pageYOffset;
    let scrollBreakPoint = this.scrollDistanceClass.offsetHeight;
    if (scrollDistance >= scrollBreakPoint) {
      Helper.addClass(this.header, "header--minimized");
      Helper.addClass(this.body, "header--minimized-active");
    } else {
      Helper.removeClass(this.header, "header--minimized");
      Helper.removeClass(this.body, "header--minimized-active");
    }
  }

  toggleMainMenu(menu, offsetX){
    this.submenuChildrenId = null;
    this.removeMenuLevelsDesktop('','',true);
    let submenu = menu.querySelector(".menu__wrap");
    if(!this.menuOpen["mobile"]){
      if(!Helper.hasClass(menu, "menu-active")){
        this.closeAllMenus();
        setTimeout(e => {
          Helper.slideDown(submenu, 200);
          Helper.addClass(menu, "menu-active");
          Helper.addClass(this.body, "menu-open");
          this.menuOpen["menu"] = true;
        },10);

        this.activeMenuArray = [];
        document.querySelectorAll(".menu__item--ancestor-active").forEach(toggle => {
          this.activeMenuArray.push(toggle);
        });

        if(this.activeMenuArray.length > 0){
          var i = 0;
          var activeMenuInt = setInterval(e => {
            let mouseoverEvent = new Event('mouseover');
            this.activeMenuArray[i].dispatchEvent(mouseoverEvent);
            if(i == this.activeMenuArray.length - 1){
              clearInterval(activeMenuInt);
            }
            i++;
          },20);
        }
      } else {
        Helper.slideUp(submenu, 100);
        Helper.removeClass(menu, "menu-active");
        Helper.removeClass(this.body, "menu-open");
        this.menuOpen["menu"] = false;
      }
    } else {
      let menu = document.querySelector("#main-menu");
      document.querySelectorAll(".main-stage").forEach(stage => {
        stage.remove();
      });
      let stage = document.createElement("div");
      stage.classList.add("main-stage");
      menu.insertAdjacentElement("beforebegin", stage);
      this.toggleMenuLevels(submenu.querySelector(".menu"), '', menu, offsetX);
    }
  }

  toggleMenuLevels(submenu, headlineLink, toggle, offsetX){
    if(Helper.hasClass(document.querySelector("body"), "menu-open")){
      this.toggleMenuLevelsDesktop(submenu, toggle);
      return;
    }

    let toggleText = "Hauptmenü";

    let lang = document.documentElement.getAttribute('lang');
    let shortLang = lang.substring(0, lang.indexOf('-'));

    if(shortLang=='en'){
      toggleText = "Main menu";
    }

    if(this.submenuMobile[this.submenuMobile.length - 1]){
      toggleText = this.submenuMobile[this.submenuMobile.length - 1].querySelector(".menu__wrap--headline").innerHTML;
    }

    document.querySelector(this.mobileContainerClass).style.display = "none";

    let stageWrapper = document.querySelector(".main-stage");
    let stage = document.createElement("div");
    stage.classList.add("main-stage__inner");
    stageWrapper.innerHTML = "";
    stageWrapper.insertAdjacentElement("afterbegin", stage);
    Helper.addClass(submenu, "menu-active");

    let goBack = document.createElement("div");
    let goBackSvg = document.createElement("span");
    goBack.classList.add("main-stage__back");
    goBackSvg.classList.add("main-stage__svg");
    goBackSvg.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="8" height="14" viewBox="0 0 8 14"><defs><clipPath><path d="M0,0H7.9V13.972H0Z" transform="translate(0)" fill="none"/></clipPath></defs><g><g><g><path d="M0,0H7.9V13.972H0Z" transform="translate(0)" fill="none"/><g clip-path="url(#clip-path)"><path class="icon-fill" d="M7.653.246a.853.853,0,0,0-1.2,0L.248,6.408a.835.835,0,0,0,0,1.189.852.852,0,0,0,1.2,0L7.653,1.435a.837.837,0,0,0,0-1.189" transform="translate(0 6.157)" fill="#00607b"/><path class="icon-fill" d="M.248.246a.836.836,0,0,0,0,1.189S3.951,5.1,3.99,5.124a1.7,1.7,0,0,0,2.294-.087L1.446.246a.852.852,0,0,0-1.2,0" transform="translate(0 0)" fill="#00607b"/></g></g></g></g></svg>';
    goBack.innerHTML= toggleText;
    goBack.insertAdjacentElement("afterbegin", goBackSvg);
    goBack.addEventListener("click", (e) => {
      stageWrapper.innerHTML = "";
      this.submenuMobile.pop();
      if(this.submenuMobile.length >= 1){
        this.submenuMobile[this.submenuMobile.length - 1].style.opacity = "1";
        stageWrapper.insertAdjacentElement("afterbegin", this.submenuMobile[this.submenuMobile.length - 1]);
      } else {
        stageWrapper.remove();
        document.querySelector(this.mobileContainerClass).style.display = "block";
        document.querySelector(this.mobileContainerClass).style.opacity = "1";
      }
    });

    let submenuClone = submenu.cloneNode(true);

    let wrapHeadline = document.createElement("li");
    let wrapHeadlineLink = document.createElement("a");

    wrapHeadlineLink.classList.add("menu__wrap--headline");
    wrapHeadlineLink.innerText = headlineLink.innerText;
    wrapHeadlineLink.href = headlineLink.href;

    if(!submenuClone.querySelector(".menu__wrap--headline")) {
      wrapHeadline.insertAdjacentElement("afterbegin", wrapHeadlineLink);
      submenuClone.insertAdjacentElement("afterbegin", wrapHeadline);
    }

    if(offsetX == undefined){
      let submenuLevel = [...submenu.classList].join("").replace(/[^0-9.]/g, '');
      if(this.activeMenuArray.length > 0){
        stageWrapper.style.opacity = "0";
        if(submenuLevel == this.activeMenuArray.length){
          setTimeout(() => {
            stageWrapper.style.opacity = "1";
            Helper.slideDown(stageWrapper, 100);
          }, 20);
        }
      }
    }

    stage.insertAdjacentElement("afterbegin", submenuClone);
    stage.insertAdjacentElement("afterbegin", goBack);

    this.submenuMobile.push(stageWrapper.querySelector(".main-stage__inner"));

    setTimeout(() => {
      this.bindMenuTogglerEvents();
    }, 10);
  }

  removeMenuLevelsDesktop(submenu, toggle, all, last = 0){
    let level2 = document.querySelector(".menu__wrap--content > .menu--level-2");
    let level3 = document.querySelector(".menu__wrap--content > .menu--level-3");

    if(last != 0){
      if(document.querySelector(".menu__wrap--content > .menu--level-" + last)) {
        document.querySelector(".menu__wrap--content > .menu--level-" + last).remove();

        this.submenuId = null;
        this.submenuChildrenId = null;

        if(document.querySelector(".menu--level-" + (last - 1) + " .menu__item--subopened")) {
          document.querySelectorAll(".menu--level-" + (last - 1) + " .menu__item--subopened").forEach(menu => {
            menu.classList.remove("menu__item--subopened");
          });
        }
      }
    } else {
      if(all) {
        if(level2) level2.remove();
        if(level3) level3.remove();

        if(document.querySelector(".menu__item--subopened")) {
          document.querySelectorAll(".menu__item--subopened").forEach(menu => {
            menu.classList.remove("menu__item--subopened");
          });
        }
      } else {
        if(Helper.hasClass(toggle, "menu__item--subopened")) {

          if(Helper.hasClass(submenu, "menu--level-2")) {
            level2.remove();
            if(level3) level3.remove();
          } else {
            if(level3) level3.remove();
          }

          toggle.classList.remove("menu__item--subopened");
        }

        if(Helper.hasClass(submenu, "menu--level-2")) {
          if(level2 && level3) {
            level2.remove();
            level3.remove();
          } else if(level2){
            level2.remove();
          }

          if(document.querySelector(".menu__item--subopened")) {
            document.querySelectorAll(".menu__item--subopened").forEach(menu => {
              menu.classList.remove("menu__item--subopened");
            });
          }
        } else {
          if(level3){
            level3.remove();
          }
        }
      }
    }
  }

  toggleMenuLevelsDesktop(submenu, toggle){
    let stage = toggle.closest(".menu__wrap--content");

    this.removeMenuLevelsDesktop(submenu, toggle);

    toggle.classList.add("menu__item--subopened");

    let submenuClone = submenu.cloneNode(true);
    let wrapHeadline = document.createElement("li");
    let headline = toggle.querySelector(".menu__link-text").innerText;
    wrapHeadline.classList.add("menu__wrap--headline");
    wrapHeadline.innerText = headline;

    submenuClone.insertAdjacentElement("afterbegin", wrapHeadline);
    stage.insertAdjacentElement("beforeend", submenuClone);

    this.bindMenuTogglerEvents(submenuClone);
  }

  toggleMenu(menuContainer, menuClass, toggle) {
    this.submenuMobile = [];
    if(this.menuOpen[menuClass]){
      this.closeMenu(menuContainer, menuClass);
      toggle.classList.remove(menuClass + "-active");
    } else {
      this.closeAllMenus();
      if(menuClass == "search"){
        Helper.slideDown(document.querySelector("#nswow-search-box"), 100);
      } else {
        if(menuClass == "mobile"){
          this.activeMenuArray = [];
          document.querySelectorAll(".menu__item--ancestor-active").forEach(toggle => {
            this.activeMenuArray.push(toggle);
          });
          if(this.activeMenuArray.length > 0){
            menuContainer.forEach(menu => {
              menu.style.opacity = "1";
            });
          }
        }
        menuContainer.forEach(menu => {
          menu.classList.add(menuClass + "-active");
          Helper.slideDown(menu, 100);
          if(menuClass == "report"){
            let maxMenuHeight = document.documentElement.clientHeight - document.querySelector(".header").clientHeight;
            menu.style.maxHeight = maxMenuHeight + "px";
            if(menu.querySelector(".menu").clientHeight > maxMenuHeight){
              menu.classList.add("overflow-y-scroll");
              this.body.classList.add("no-scroll");
            }
          }
        });
      }
      toggle.classList.add(menuClass + "-active");
      this.body.classList.add(menuClass + "-open");
      this.menuOpen[menuClass] = true;
    }
  }

  closeMenu(menuContainer, menuClass) {
    this.body.classList.remove("no-scroll");
    menuContainer.forEach(menu => {
      menu.classList.remove(menuClass + "-active");
      menu.classList.remove("overflow-y-scroll");
      Helper.slideUp(menu, 10);
    });
    if(menuClass == "menu"){
      if(document.querySelector(".menu-active")){
        document.querySelector(".menu-active").classList.remove("menu-active");
      }
    }
    if(menuClass == "search"){
      Helper.slideUp(document.querySelector("#nswow-search-box"), 100);
    }
    this.body.classList.remove(menuClass + "-open");
    if(document.querySelector(".main-stage")){
      document.querySelectorAll(".main-stage").forEach(stage => {
        stage.remove();
      });
    }
    this.menuOpen[menuClass] = false;
    document.querySelectorAll("." + menuClass + "-active").forEach(menu => {
      menu.classList.remove(menuClass + "-active");
    });
  }

  closeAllMenus(checkMousover = false){
    if(checkMousover){
      if(!this.closeSubmenu){
        this.closeSubmenu = false;
        this.submenuId = null;
        return;
      }
    }
    if(this.menuOpen["menu"]) {
      this.closeMenu(this.menuContainer, "menu");
    }
    if(this.menuOpen["mobile"]) {
      this.closeMenu(this.mobileContainer, "mobile");
    }
    if(this.menuOpen["language"]) {
      this.closeMenu(this.languageContainer, "language");
    }
    if(this.menuOpen["search"]) {
      this.closeMenu(this.searchContainer, "search");
    }
    if(this.menuOpen["report"]) {
      this.closeMenu(this.reportContainer, "report");
    }

    this.closeSubmenu = false;
    this.submenuId = null;
  }

  adjustSearch(){
    document.querySelectorAll("#nswow-search-box .result-title a").forEach(result => {
      if(result.getAttribute("href").indexOf("highlight") == -1){
        result.setAttribute("href", result.getAttribute("href") + "?highlight=" + document.querySelector("#nswow-search-field").value);
      }
    });

console.log("adjust");

    document.querySelectorAll("#nswow-search-box .result-occurrences").forEach(result => {
      let ahref = result.previousElementSibling.firstChild.getAttribute("href");
      let resultInner = result.innerHTML;
      if(result.innerHTML.indexOf("href") == -1){
        result.innerHTML = `<a href="` + ahref + `">` + resultInner + `</a>`;
      }
    });

    if(document.documentElement.clientWidth <= 1240){
      document.querySelectorAll("#nswow-search-box .result-occurrences").forEach(result => {
        result.innerText = "(" + result.innerText.replace(/[^0-9.]/g, '') + ")";
      });
    }
  }

  adjustBreadcrumbs(){
    if(document.documentElement.clientWidth <= 1240){
      let breadcrumbs = document.querySelector(".breadcrumbs");
      if(breadcrumbs){
        let spacer = document.createElement("span");
        spacer.classList.add("breadcrumbs__spacer");
        spacer.classList.add("breadcrumbs__spacer--rotate");
        spacer.style.display = "block";
        spacer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="8" height="14" viewBox="0 0 8 14"><defs><clipPath><path d="M0,0H7.9V13.972H0Z" transform="translate(0)" fill="none"></path></clipPath></defs><g><g><g><path d="M0,0H7.9V13.972H0Z" transform="translate(0)" fill="none"></path><g clip-path="url(#clip-path)"><path class="icon-fill" d="M7.653.246a.853.853,0,0,0-1.2,0L.248,6.408a.835.835,0,0,0,0,1.189.852.852,0,0,0,1.2,0L7.653,1.435a.837.837,0,0,0,0-1.189" transform="translate(0 6.157)" fill="#00607b"></path><path class="icon-fill" d="M.248.246a.836.836,0,0,0,0,1.189S3.951,5.1,3.99,5.124a1.7,1.7,0,0,0,2.294-.087L1.446.246a.852.852,0,0,0-1.2,0" transform="translate(0 0)" fill="#00607b"></path></g></g></g></g></svg>';
        breadcrumbs.insertAdjacentElement("afterbegin", spacer);
      }
    }
  }
}
export default Header;
